
import Product from './product';

export default {
    parsePackElements(data){
        let elements = [];
        if(data && data.hasOwnProperty('packElements') && data.packElements){
            for(let i = 0; i < data.packElements.length; i++){
                let packElement = data.packElements[i];
                elements[i] = packElement instanceof Product ?  packElement : new Product(packElement);
            }
        }
        return elements;
    },
    parseChildren(data){
        let elements = [];
        if(data && data.hasOwnProperty('children') && data.children){
            for(let i = 0; i < data.children.length; i++){
                let children = data.children[i];
                elements[i] = children instanceof Product ?  children : new Product(children);
            }
        }
        return elements;
    },
    getOptionsText(data, glue, glueOpVal){
        let text = [];
        if(typeof glue === 'undefined'){
            glue = ' ';
        }
        if(data && data.hasOwnProperty('options') && data.options){
            if(typeof glueOpVal === 'undefined'){
                glueOpVal = ': ';
            }
            const options = data.options;
            for(let i = 0; i < options.length; i++){
                text.push(options[i].option + glueOpVal + options[i].value);
            }
        }
        return text.join(glue);
    },

};